import React, { useMemo } from "react";
import { Routes, Route } from "react-router-dom";
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import DashboardLayout from "./components/Layout/DashboardLayout";
// Auth pages
import { LoginEmpresa } from "./pages/auth";
import LoginPrefeitura from "./pages/auth/loginPrefeitura";

// Candidate pages
import {
  CadastrarCandidatos,
  CandidatosAprovados,
  ListarCandidatos,
  PerfilCandidato,
} from "./pages/candidato";
import LoginCandidato from "./pages/candidato/loginCandidato";
import RecuperarSenhaCandidato from "./pages/candidato/recuperarSenhaCandidato";

// Company pages
import {
  CadastrarEmpresa,
  ConfiguracoesEmpresa,
  DashboardEmpresa,
  ListarEmpresas,
} from "./pages/empresa";

// Job pages
import {
  Aprovacoes,
  CadastrarVaga,
  GerenciarVagas,
  PainelVagas,
  VagasPublicas,
} from "./pages/vaga";

// Prefeitura pages
import {
  Dashboard,
  GestaoPrefeitura,
  ListarVagasPrefeitura,
  ListarEmpresasPermitidas,
  ConfiguracoesPrefeitura,
} from "./pages/prefeitura";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";

function AppContent() {
  const { darkMode } = useTheme();

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: darkMode ? "dark" : "light",
          primary: {
            main: "#1976d2",
          },
          secondary: {
            main: "#dc004e",
          },
          background: {
            default: darkMode ? "#121212" : "#f5f5f5",
            paper: darkMode ? "#1e1e1e" : "#ffffff",
          },
        },
        typography: {
          fontFamily: "Montserrat, Inter, Arial, sans-serif",
          h4: {
            fontWeight: 600,
          },
          h5: {
            fontWeight: 600,
          },
          h6: {
            fontWeight: 600,
          },
        },
        components: {
          MuiButton: {
            styleOverrides: {
              root: {
                textTransform: "none",
                borderRadius: 8,
              },
            },
          },
          MuiPaper: {
            styleOverrides: {
              root: {
                borderRadius: 12,
              },
            },
          },
        },
      }),
    [darkMode],
  );

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {/* FLUXO 1: Candidatos (Público - sem sidebar) */}
        {/* Raiz mostra as vagas públicas direto (sem login); o cadastro fica em /vagas */}
        <Route path="/" element={<VagasPublicas />} />
        <Route path="/login-candidato" element={<LoginCandidato />} />
        <Route
          path="/recuperar-senha-candidato"
          element={<RecuperarSenhaCandidato />}
        />
        <Route path="/painel-vagas" element={<PainelVagas />} />
        <Route path="/perfil-candidato" element={<PerfilCandidato />} />

        {/* Cadastro de candidato */}
        <Route path="/vagas" element={<CadastrarCandidatos />} />

        {/* FLUXO 2: Empresas (Login e área privada) */}
        <Route path="/login-empresa" element={<LoginEmpresa />} />
        <Route path="/cadastrar-empresa" element={<CadastrarEmpresa />} />

        {/* FLUXO 2B: Prefeitura (Login) */}
        <Route path="/login-prefeitura" element={<LoginPrefeitura />} />

        {/* FLUXO 3: Áreas com sidebar (Empresa e Prefeitura) */}
        <Route element={<DashboardLayout />}>
          {/* Área da Empresa */}
          <Route path="/dashboard-empresa" element={<DashboardEmpresa />} />
          <Route path="/aprovacoes" element={<Aprovacoes />} />
          <Route path="/gerenciar-vagas" element={<GerenciarVagas />} />
          <Route path="/cadastrar-vaga" element={<CadastrarVaga />} />
          <Route
            path="/candidatos-aprovados"
            element={<CandidatosAprovados />}
          />
          <Route
            path="/configuracoes-empresa"
            element={<ConfiguracoesEmpresa />}
          />

          {/* Área da Prefeitura */}
          <Route path="/dashboard-prefeitura" element={<Dashboard />} />
          <Route path="/listar-empresas" element={<ListarEmpresas />} />
          <Route path="/listar-candidatos" element={<ListarCandidatos />} />
          <Route path="/listar-empresas-permitidas" element={<ListarEmpresasPermitidas />} />
          <Route path="/gestao-prefeitura" element={<GestaoPrefeitura />} />
          <Route
            path="/listar-vagas-prefeitura"
            element={<ListarVagasPrefeitura />}
          />
          <Route
            path="/configuracoes-prefeitura"
            element={<ConfiguracoesPrefeitura />}
          />
        </Route>
      </Routes>
    </MuiThemeProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
